import $ from "jquery"

$('.js-people-trigger').each(function(){
    const thisHtml = $(this).closest('.people__item').find('.people__content').html();

    $(this).on('click', function(){
        $('.js-people-info').html(thisHtml);
        $('.people__item').removeClass('people__item--active');
        $(this).closest('.people__item').addClass('people__item--active');
    });
});